import React, {useContext, useEffect, useState} from "react";
import {GameApi} from "../../services/api/GameApi";
import {GameMode} from "../../models/GameMode";
import {CardChooseGameMode} from "../gameMods/chooseGameMode/cardChooseGameMode";
import {AppContext} from "../authProvider/AuthProvider";
import {useTranslation} from "react-i18next";


export const Home: React.FC = () => {
    const [gameMode, setGameMode] = useState<GameMode[]>([]);
    const {errorToast} = useContext(AppContext);
    const {t} = useTranslation();

    useEffect(() => {
        GameApi.getSoloClassicGameMode().then((data) => {
            if (data !== null) {
                setGameMode(data)
            }
        })
        .catch(() => errorToast());
    }, []);

    return (
        <div className="flex flex-col w-full justify-center gap-20 md:gap-60 px-8 pt-24">
            <h1 className="text-5xl text-center">
                {t("home.welcome-on-fastype")}
            </h1>

            <div className="flex flex-col md:flex-row md:justify-around gap-20">
                <div className="flex flex-col justify-center w-full md:w-1/3 gap-10">
                    <h2 className="text-2xl text-center">
                        {t("home.what-is-fastype")}
                    </h2>

                    <p className="text-justify">
                        {t("home.fastype-description")}
                    </p>
                </div>

                <div className="flex flex-col w-full md:w-1/3 gap-10">
                    <h2 className="text-2xl text-center">
                        {t("home.best-gamemodes")}
                    </h2>

                    <div className="flex justify-center md:w-full">
                        {gameMode.length === 0 ? <div>{t("global.loading")}</div> :
                            gameMode.map((element) => {
                                return (
                                    <CardChooseGameMode key={element.id} gameMode={element}/>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
